// extracted by mini-css-extract-plugin
export default {"th":"TableHeader_th__WC2P4"};